import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userInfoSlice from '../reducers/userInfoSlice';
import sidebarSlice from '../reducers/sidebarSlice';
import userTransactionsSlice from '../reducers/userTransactionsSlice';
import franchiseNotifcationsSlice from '../reducers/franchiseNotifactionsSlice';
import betRequestsSlice from '../reducers/betRequestsSlice';
import betListSlice from '../reducers/betsListSlice';
import sportReportReducer from '../reducers/sportReportSlice';
import commandMenuReducer from '../reducers/commandMenuSlice';

export const store = configureStore({
  reducer: {
    userInfo: userInfoSlice,
    sidebar: sidebarSlice,
    userTransactions: userTransactionsSlice,
    franchiseNotifications: franchiseNotifcationsSlice,
    betRequests: betRequestsSlice,
    betsList: betListSlice,
    sportReports: sportReportReducer,
    commandMenu: commandMenuReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
